<template>
  <div class="scene artistTile" :data-letter="getDataLetter()">
    <div class="card" :class="{ 'is-flipped': flipped === true }">
      <div
        class="card_face card_face--front cursor-pointer"
        v-on:click="toggleFlip()"
      >
        <div class="img" v-bind:style="imgStyles"></div>
        <div class="title">
          {{ artist.title.trim() }}
          <hr />
        </div>
      </div>
      <div class="card_face card_face--back">
        <div class="title cursor-pointer" v-on:click="toggleFlip()">
          <div class="back">
            <font-awesome-icon :icon="['fas', 'angle-left']" />
          </div>
          <div class="face-back-title">
            {{ artist.title }}
            <hr />
          </div>
        </div>
        <artistDetail
          :artist="artist"
          :initLoad="flipped"
          @toggleFlip="toggleFlip"
          class="artistDetail"
        />
      </div>
    </div>
  </div>
</template>

<script>
import artistDetail from "./artistDetail.vue";
export default {
  name: "artistTile",
  data: function () {
    return {
      flipped: false,
      imgLoaded: false,
      imgStyles: {},
    };
  },
  components: {
    artistDetail,
  },
  props: {
    artist: Object,
  },
  mounted() {
    // do lazy loading of images and flip the tiles over when they come into view
    if ("IntersectionObserver" in window) {
      let options = {
        root: document.querySelector("#scrollArea"),
        rootMargin: "150px",
        threshold: 0,
      };
      let observer = new IntersectionObserver(this.tileObserver, options);
      observer.observe(this.$el);
    } else {
      // cant do lazy loading images
      this.imgStyles = {
        backgroundImage: `url(${this.artist.photo})`,
      };
      this.imgLoaded = true;
    }
  },
  methods: {
    toggleFlip() {
      this.flipped = !this.flipped;
    },
    tileObserver(entries) {
      // flip the tile back over when it comes into view
      if (entries[0].isIntersecting && this.flipped) {
        this.toggleFlip();
      }
      // lazy load the image
      if (entries[0].isIntersecting && !this.imgLoaded) {
        this.imgStyles = {
          backgroundImage: `url(${this.artist.photo})`,
        };
        this.imgLoaded = true;
      }
    },
    getDataLetter() {
      const firstLetter = this.artist.title.slice(0, 1).toUpperCase();
      return /^[a-zA-Z()]$/.test(firstLetter) ? firstLetter : "#";
    },
  },
};
</script>
